import { createApp } from 'vue'
import ViewUIPlus from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import 'view-ui-plus/dist/styles/viewuiplus.css'

import VueCookies from 'vue-cookies'


// 引入iconfont
import "@/assets/iconfont/iconfont.css"
// 强制覆盖主view-ui-plus主题色
import '@/theme/theme.css'


createApp(App).use(router).use(ViewUIPlus).use(VueCookies).mount('#app')



